// extracted by css-extract-rspack-plugin
export default {"dialog-paper-root":"EntityPickerPopover_dialog-paper-root__a9nqp","popover-paper-root":"EntityPickerPopover_popover-paper-root__+5NYN"};